import { resetStatusFilter } from './status';
import { resetOtherFilter } from './otherFilters';
import { onResetSearchFilter } from './search';

export function resetFilters() {
  resetStatusFilter();
  resetOtherFilter();
  onResetSearchFilter();
}
